module.exports = __webpack_public_path__ + "static/media/Download_on_the_App_Store_Badge_US-UK_135x40.d0558d91.svg";